import { View } from "@/components/ui";
import { Package as PackageIcon } from "@/components/shared/icons";
import { PackageList } from "../package-list";
import { AccountMyReferralBanner } from "@/containers/profile/account-my-referral/account-my-referral-banner";
import { MakeABooking } from "@/containers/make-a-booking";
import { Typography } from "@/components/shared/typography";
import { IconButton } from "@/components/ui/icon-button/index.web";
import { useRoute } from "@/components/shared/router";
import { useWindowDimensions } from "@/components/hooks/use-window-dimension";

export const Packages = () => {
  const { push } = useRoute();
  const { isMobile } = useWindowDimensions();
  return (
    <View className="flex flex-col gap-3 p-3 md:p-0">
      <View className="static flex flex-row items-center justify-between">
        <View className="mb-4 flex flex-row items-center">
          {/* CONSISTENECY PROBLEM   <Link href="/profile/overview">
            <ArrowLeft className="size-5" />
          </Link> */}
          <IconButton
            variant={isMobile ? "ghost" : "secondary"}
            color="foreground"
            iconName="arrowLeft"
            rounded="full"
            className="p-0 md:hidden md:px-3 md:py-2"
            onClick={() => push({ pageKey: "profile" })}
          />
          <Typography variant="label-md">Packages</Typography>
        </View>
      </View>

      <AccountMyReferralBanner />

      <View className="flex flex-row gap-3 py-3">
        <PackageIcon size={28} weight="fill" className="text-primary" />
        <Typography className="text-lg">Your Packages</Typography>
      </View>

      <PackageList />

      <MakeABooking />
    </View>
  );
};
